// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__28NpQ","content":"styles_content__1h3WG","checkbox":"styles_checkbox__3MH8i","checkboxLabel":"styles_checkboxLabel__2CCqQ"};